module.exports = __webpack_public_path__ + "img/icon4.782aaa50.svg";